module.exports = __webpack_public_path__ + "media/cycles-games-over@sm-084dee087190e217a2286e4cd909d47b.jpg";